import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const LoginContent = (props) => {
  const { anim } = props;
  return (
    <Wrapper className="content-box-wrapper">
      <span className="heading">
        Business payments made <b>super easy.</b>
      </span>
      <p className="sub-title">
        Payment solutions built to work for your business
      </p>
      <img src="./images/login.png" className={`gpk active`} alt="Graphic" />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  overflow: hidden;
  height: 100%;
  position: relative;
  .gpk {
    width: 100%;
    max-height: 40vh;
    object-fit: contain;
    position: absolute;
    bottom: 0;
    transition: all 0.3s ease;
    &.active {
      bottom: 0;
    }
  }
`;

export default LoginContent;
